// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-center[data-v-42ef63e2]{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%)}.section__loader[data-v-42ef63e2]{margin:1rem}.timeline__messages[data-v-42ef63e2]{margin:0;padding:1rem;list-style:none}.timeline__message[data-v-42ef63e2]{margin-bottom:1rem}.timeline__archives__button[data-v-42ef63e2]{text-align:center}", ""]);
// Exports
module.exports = exports;
